module.exports = __webpack_public_path__ + "img/plexus-12.65ff8325.png";